<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="用户信息"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="135px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
      :show-save-button="$permission.canEdit()"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="用户类型" prop="PersonType">
              <el-select
                v-model="data.PersonType"
                placeholder="请选择用户类型"
                clearable
              >
                <el-option label="个人用户" :value="0"></el-option>
                <el-option label="企业用户" :value="1"></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="昵称" prop="NickName">
              <el-input
                v-model="data.NickName"
                placeholder="请输入昵称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="姓名" prop="PersonName">
              <el-input
                v-model="data.PersonName"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="编号" prop="PersonCode">
              <el-input
                v-model="data.PersonCode"
                placeholder="请输入编号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="性别" prop="PersonSex">
              <el-radio-group v-model="data.PersonSex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
                <el-radio :label="2">保密</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
         <el-col :span="isMB ? 24 : 12" v-if="data.PersonType==1">
            <el-form-item label="联系人" prop="ContactName">
              <el-input
                v-model="data.ContactName"
                placeholder="请输入联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="手机号码" prop="ContactPhone">
              <el-input
                v-model="data.ContactPhone"
                placeholder="请输入手机号码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="身份证号码" prop="PersonIdno">
              <el-input
                v-model="data.PersonIdno"
                placeholder="请输入身份证号码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="用户等级" prop="PersonGradeid">
              <el-select
                v-model="data.PersonGradeid"
                placeholder="请选择用户等级"
                clearable
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.GradeName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12"  v-if="data.PersonType==1"> 
            <el-form-item label="统一社会信用代码" prop="LicenseCode">
              <el-input
                v-model="data.LicenseCode"
                placeholder="请输入身份证号码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!--<el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员标签" prop="PersonLabel">
              <el-input v-model="data.PersonLabel" placeholder="请选择会员标签" clearable></el-input>
            </el-form-item>
           </el-col> -->
        </el-row>

        <el-row v-if="false">
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员积分" prop="PersonPoints">
              <el-input
                v-model="data.PersonPoints"
                placeholder="请选择会员积分"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员余额" prop="PersonBalance">
              <el-input v-model="data.PersonBalance" placeholder="请选择会员余额" clearable></el-input>
            </el-form-item>
           </el-col> -->

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="0">未实名</el-radio>
                <el-radio :label="1">已实名</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-form">
          <el-col :span="24">
            <el-form-item label="身份证照" prop="IdnoPhoto">
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'IdnoPhoto');
                    }
                  "
                  :headers="headers"
                  :file-list="IdnoPhoto"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'IdnoPhoto');
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip
                  class="upload-tip"
                  effect="light"
                  content="图片格式须为jpg、png, 可上传多图"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-form"  v-if="data.PersonType==1">
          <el-col :span="24">
            
              <el-form-item
              :label="isMB ? '' : '营业执照'"
              :label-width="isMB ? '0' : ''"
              prop="LicensePhoto"
            >
              <el-divider v-if="isMB">营业执照</el-divider>
              <single-pic-upload
                v-model="data.LicensePhoto"
                type="LicensePhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
            <!-- <el-form-item label="营业执照" prop="LicensePhoto">
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'LicensePhoto');
                    }
                  "
                  :headers="headers"
                  :file-list="LicensePhoto"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'LicensePhoto');
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip
                  class="upload-tip"
                  effect="light"
                  content="图片格式须为jpg、png, 可上传多图"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item> -->
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '头像'"
              :label-width="isMB ? '0' : ''"
              prop="ProfilePhoto"
            >
              <el-divider v-if="isMB">头像</el-divider>
              <single-pic-upload
                v-model="data.ProfilePhoto"
                type="ProfilePhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="false">
            <el-form-item
              :label="isMB ? '' : '二维码'"
              :label-width="isMB ? '0' : ''"
              prop="QrCode"
            >
              <el-divider v-if="isMB">二维码</el-divider>
              <single-pic-upload
                v-model="data.QrCode"
                type="QrCode"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="注册时间" prop="RegisterTime">
              {{data.RegisterTime}}
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="OpenId" prop="OpenId">
              <el-input
                v-model="data.OpenId"
                placeholder="请输入OpenId"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  props: {},
  computed: {
    host() {
      return window.location.origin; //获取当前网站的域名，用于上传多图那里
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OpenId: "",
        PersonCode: "",
        State: 0, //写道这里
        QrCode: "",
        ContactPhone: "",
        ProfilePhoto: "",
        NickName: "",
        PersonName: "",
        PersonSex: 1,
        PersonIdno: "",
        PersonGradeid: null,
        RegisterTime: this.$commonJs.getNowDatetimeString(),
        IdnoPhoto: "",
        PersonLabel: "",
        PersonPoints: null,
        PersonBalance: null,
        LicensePhoto: "",
        LicenseCode: "",
        PersonType:null,
        DataSource:0
      },
      saveState: 0,
      gradeList: [],
      IdnoPhoto: [],
      LicensePhoto: [],

      dialogImageUrl: "",
      dialogVisible: false,
      api: require("@/api/person/personinfo").default,
      api2: require("@/api/person/persongrade").default,
      headers: { Authorization: "Bearer " + this.$commonJs.getCookie("token") }, //传图片时加上token
      isMB: this.$store.state.isMB,
      rules: {
        PersonName: [{ required: true, message: "姓名不能为空" }],
        //NickName: [{ required: true, message: "昵称不能为空" }],
        PersonGradeid: [{ required: true, message: "用户等级不能为空" }],
        PersonSex: [{ required: true, message: "性别不能为空" }],
        PersonType: [{ required: true, message: "用户类型不能为空" }],
        ContactPhone: [
          { required: true, message: "手机号码不能为空" },
          { validator: this.$commonJs.validateRules.validPhone },
        ],
        PersonIdno: [{ validator: this.$commonJs.validateRules.idCard }],

        //  ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
      },

      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
    },
    onEditOpened(data) {
      this.getOption();
      if (data.IdnoPhoto) {
        data.IdnoPhoto.split(",").forEach((e) => {
          this.IdnoPhoto.push({
            url: "/api" + e,
            url2: e,
          });
        });
      }
      if (data.LicensePhoto) {
        data.LicensePhoto.split(",").forEach((e) => {
          this.LicensePhoto.push({
            url: "/api" + e,
            url2: e,
          });
        });
      }
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.gradeList = res.Data;
        }
      });
    },
    beforePhotoUpload(file) {
      const is500k = file.size / 1024 <= 2048;
      if (!is500k) {
        this.$message.error("照片大小不能超过2M");
      }
      return is500k;
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: "/api" + res.Data, url2: res.Data });
      } else {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error(res.Msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileRemove(file, fileList, name) {
      var index = this[name].findIndex((x) => x.url == file.url);
      if (index > -1) {
        this[name].splice(index, 1);
      }
    },
    onExceed() {
      this.$message.error("超过上传数量限制");
    },

    onBeforeSave() {
      var place = "";
      this.IdnoPhoto.forEach((e, index) => {
        place += e.url2;
        if (index < this.IdnoPhoto.length - 1) {
          place += ",";
        }
      });
      this.data.IdnoPhoto = place;
      var place2 = "";
      this.LicensePhoto.forEach((e, index) => {
        place2 += e.url2;
        if (index < this.LicensePhoto.length - 1) {
          place2 += ",";
        }
      });
      this.data.LicensePhoto = place2;
    },
    onClosed() {
      this.gradeList = [];
      this.IdnoPhoto = [];
      this.LicensePhoto = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-tip {
  transform: translateY(26px);
  margin-left: 10px;
}
</style>
